import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { ICostTypeCostCenterDistribution } from '../../../../models/cost-type-cost-center-distribution.model';
import { JoinCostTypeCostCenterFacade } from '../../../../services/facades/master-data/join-cost-type-cost-center.facade';
import { IJoinCostTypeCostCenterState } from '../../../../services/facades/master-data/join-cost-type-cost-center-state.model';
import { Observable } from 'rxjs';

@Component({
    templateUrl: './join-cost-type-cost-center-dialog.component.html',
    styleUrls: [ './join-cost-type-cost-center-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JoinCostTypeCostCenterDialogComponent implements OnInit, AfterViewInit {
    public costTypeDistributionState$: Observable<IJoinCostTypeCostCenterState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        private myMatDialogRef: MatDialogRef<JoinCostTypeCostCenterDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostTypeCostCenterDistribution,
        private myCostTypeDistributionFacade: JoinCostTypeCostCenterFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costTypeDistributionState$ = this.myCostTypeDistributionFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((distribution: ICostTypeCostCenterDistribution) => {
            this.validateDialogFields(distribution);
        });
    }

    public save(): void {
        const data: ICostTypeCostCenterDistribution = this.formGroup.value as ICostTypeCostCenterDistribution;
        if (isNullOrUndefined(this.data.id)) {
            void this.myCostTypeDistributionFacade.addCostTypeCostCenterDistribution(data);
        } else {
            data.id = this.data.id;
            data.costCenterId = this.data.costCenterId;
            void this.myCostTypeDistributionFacade.updateCostTypeDistribution(data);
            this.close();
        }
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(distribution: ICostTypeCostCenterDistribution): void {
        if ((isNullOrUndefined(distribution.costCenterId) && isNullOrUndefined(this.data.costCenterId))
        || isNullOrUndefined(distribution.costingLevelId)
        || isNullOrUndefined(distribution.contributionMarginLevelId)
        || isNullOrUndefined(distribution.variable)) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
